import React, { useState } from 'react'
import { Segmented, Typography } from 'antd'
import { SwapOutlined, AppstoreOutlined } from '@ant-design/icons'
import MovementReportsSection from './movements/MovementReportsSection'
import InventoryReportsSection from './inventory/InventoryReportsSection'

const { Title } = Typography

type TMainReportSection = 'movements' | 'inventory'

export const ViewStorageReports: React.FC = () => {
  const [activeSection, setActiveSection] = useState<TMainReportSection>('movements')

  return (
    <div className="container-fluid">
      <div style={{ marginBottom: 16, display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: 12 }}>
        <Title level={4} style={{ margin: 0, color: '#373738' }}>Informes de Almacén e Inventario</Title>

        <Segmented
          value={activeSection}
          onChange={(value) => setActiveSection(value as TMainReportSection)}
          size="large"
          options={[
            {
              label: (
                <div style={{ padding: '4px 12px', fontWeight: 500 }}>
                  <SwapOutlined style={{ marginRight: 8, color: '#1890ff' }} />
                  Informes de Movimientos
                </div>
              ),
              value: 'movements'
            },
            {
              label: (
                <div style={{ padding: '4px 12px', fontWeight: 500 }}>
                  <AppstoreOutlined style={{ marginRight: 8, color: '#52c41a' }} />
                  Informes de Inventario
                </div>
              ),
              value: 'inventory'
            }
          ]}
        />
      </div>

      <div className="card shadow" style={{ marginBottom: 16 }}>
        <div className="card-body">
          {activeSection === 'movements' ? (
            <MovementReportsSection />
          ) : (
            <InventoryReportsSection />
          )}
        </div>
      </div>
    </div>
  )
}

export default ViewStorageReports
